export const InvestorType = {
	Retail: 'Retail',
	Professional: 'Professional',
	Corporate: 'Corporate',
	CorporateRetail: 'CorporateRetail',
};

export const isCorporateType = (name) =>
	name === InvestorType.Corporate || name === InvestorType.CorporateRetail;
